<script lang="ts" setup>
const model = defineModel<any>();
</script>

<template>
    <PrimeTextarea v-model="model" fluid />
</template>
